import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface WaitingStatusProps {
  received: boolean;
  statusLabel: string;
  viewLabel: string;
  onViewItem: () => void;
  isViewLoading?: boolean;
  isViewDisabled?: boolean;
}

export const WaitingStatus = ({
  received,
  statusLabel,
  viewLabel,
  onViewItem,
  isViewLoading = false,
  isViewDisabled = false,
}: WaitingStatusProps) => (
  <div
    className={cn(
      "flex flex-col gap-3 rounded-xl border px-4 py-3 transition-colors sm:flex-row sm:items-center sm:justify-between",
      received
        ? "border-green-200 bg-green-50 text-green-900"
        : "border-amber-200 bg-amber-50 text-amber-900",
    )}
  >
    <div className="flex min-w-0 items-start gap-3">
      <span className="relative mt-1.5 flex h-2.5 w-2.5 shrink-0 items-center justify-center">
        {!received && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75" />
        )}
        <span
          className={cn(
            "relative inline-flex h-2.5 w-2.5 rounded-full",
            received ? "bg-green-500" : "bg-amber-500",
          )}
        />
      </span>
      <div className="min-w-0">
        <p className="text-sm font-semibold">{statusLabel}</p>
        <p className={cn("mt-0.5 text-xs", received ? "text-green-800" : "text-amber-800")}>
          {received ? "You're all set!" : "Run the snippet below to get started!"}
        </p>
      </div>
    </div>

    <Button
      type="button"
      size="sm"
      variant={received ? "default" : "secondary"}
      className="shrink-0 self-start sm:self-center"
      onClick={onViewItem}
      disabled={!received || isViewDisabled}
      isLoading={isViewLoading}
    >
      {viewLabel}
    </Button>
  </div>
);
